module.exports = __webpack_public_path__ + "img/preview-14.67f5db19.png";